import { combineReducers } from 'redux';

import {
    APPLICATION_CONTAINER_INITIALIZED,
    APPLICATION_CONTAINER_SET_CONFIG
} from 'common/actions/applicationContainer';

function initialized(state = false, action){
    if(action.type === APPLICATION_CONTAINER_INITIALIZED) {
        return true;
    }
    return state;
}

function config(state = null, action){
    if(action.type === APPLICATION_CONTAINER_SET_CONFIG){
        return action.payload;
    }
    return state;
}

export const applicationContainer = combineReducers({
    initialized,
    config
});

const applicationContainerMatcher = /^APPLICATION_CONTAINER_/;
export default function applicationContainerReducer(state, action) {
    if(!applicationContainerMatcher.test(action.type) && action.type !== '@@INIT') {
        return state;
    }
    return {
        ...state,
        application: applicationContainer(state.application, action)
    };
}
